import { render, staticRenderFns } from "./mobileContent2.vue?vue&type=template&id=08aac76f&scoped=true"
import script from "./mobileContent2.vue?vue&type=script&lang=js"
export * from "./mobileContent2.vue?vue&type=script&lang=js"
import style0 from "./mobileContent2.vue?vue&type=style&index=0&id=08aac76f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aac76f",
  null
  
)

export default component.exports